import { environment } from '../environments/environment.prod';

export class AppSettings {
  public static API_URI = environment.backend;
  public static API_LOGIN = environment.login;
  public static API_ASSETS = environment.assets;
}
